<template>
<div class="chapter">
<div class="inner_page">
<p class="poem3" id="start"><a id="part1"></a><a id="chap1">We ran like young wild furies,</a></p><a id="chap1">
<p class="poem3">where angels feared to tread.</p>
<p class="poem3">The woods were dark and deep.</p>
<p class="poem3">Before us demons fled.</p>
<p class="poem3">We checked Coke bottle bottoms</p>
<p class="poem3">to see how far was far.</p>
<p class="poem3">Our worlds of magic wonder</p>
<p class="poem3">were never reached by car.</p>
<p class="poem3">We loved our dogs like brothers,</p>
<p class="poem3">our bikes like rocket ships.</p>
<p class="poem3">We were going to the stars,</p>
<p class="poem3">to Mars we’d make round trips.</p>
<p class="poem3">We swung on vines like Tarzan,</p>
<p class="poem3">and flashed Zorro’s keen blade.</p>
<p class="poem3">We were James Bond in his Aston,</p>
<p class="poem3">we were Hercules unchained.</p>
<p class="poem3">We looked upon the future</p>
<p class="poem3">and we saw a distant land,</p>
<p class="poem3">where our folks were always ageless,</p>
<p class="poem3">and time was shifting sand.</p>
<p class="poem3">We filled up life with living,</p>
<p class="poem3">with grins, scabbed knees, and noise.</p>
<p class="poem3">In glass I see an older man,</p>
<p class="poem3">but this book’s for the boys.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-start.vue?694fcadd